import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { I18nextProvider } from 'react-i18next';
import { StylesProvider } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { PersistGate } from 'redux-persist/lib/integration/react';

import './index.scss';
import * as serviceWorker from './service-worker';
import store, { persistor, history } from './configs/store';
import i18n from './configs/i18n';
import loader from './assets/images/loader.webm';
import Orientation from './containers/Orientation/Orientation';
import AppMode from './containers/AppMode/AppMode';
import App from './App';

ReactDOM.render(
  <StylesProvider injectFirst>
    <Provider store={ store }>
      <PersistGate persistor={ persistor }>
        <ConnectedRouter history={ history }>
          <I18nextProvider i18n={ i18n }>
            <MuiPickersUtilsProvider utils={ DateFnsUtils }>
              <AppMode>
                <Orientation>
                  <Suspense fallback={ <img src={ loader } style={ { width: '100vw', height: '100vh' } } /> }>
                    <App />
                  </Suspense>
                </Orientation>
              </AppMode>
            </MuiPickersUtilsProvider>
          </I18nextProvider>
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  </StylesProvider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

export default store;
